import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_workspace/ide-next/")({
  component: () => null,
});
